import BaseApi from "../../BaseApi";
import { headers } from "../../ApiSettings";

class Profile extends BaseApi {
  constructor() {
    super({ suffix: "" });
  }

  getAllCountrybySid(params) {
    return this.httpService.get("Definition/all-country-profile-sid", {
      headers,
      params,
    });
  }

  getAllSeriesByCountry(params) {
    return this.httpService.get("Definition/seri-brand-profile-limit", {
      headers,
      params,
    });
  }

  getAllBrandByCountry(params) {
    return this.httpService.get("Definition/all-brand-profile-country", {
      headers,
      params,
    });
  }

  UpdatePriceProfile(data) {
    return this.httpService.put("Definition/set-price-product-profile", data, {
      headers,
    });
  }

  UpdateWeightProfile(data) {
    return this.httpService.put("Definition/update-weight", data, {
      headers,
    });
  }

  getAllDasteProfile(params) {
    return this.httpService.get("Definition/list-all-group-profile", {
      headers,
      params,
    });
  }

  getAllPriceProductProfile(params) {
    return this.httpService.get("Definition/List-price-product-profile", {
      headers,
      params,
    });
  }

  UpdateSettingProfile(data) {
    return this.httpService.put(
      "Definition/update-setting-group-profile",
      data,
      { headers }
    );
  }

  deleteDasteProfile(data) {
    return this.httpService.delete("Definition/delete-group-profile", {
      headers,
      data,
    });
  }

  getRelationDasteProfile(params) {
    return this.httpService.get("Definition/relation-group-profile", {
      headers,
      params,
    });
  }

  disableDasteProfile(data) {
    return this.httpService.put("Definition/disable-group-profile", data, {
      headers,
    });
  }

  getAllCountryProfile(params) {
    return this.httpService.get("Definition/list-all-group-profile", {
      headers,
      params,
    });
  }

  InsertDasteProfile(data) {
    return this.httpService.post("Definition/add-group-profile-color", data, {
      headers,
    });
  }

  getAlltypeColor(params) {
    return this.httpService.get("Definition/List-type-color-in-group-profile", {
      headers,
      params,
    });
  }

  UpdateTypeProfileName(data) {
    return this.httpService.put("Definition/update-type-color", data, {
      headers,
    });
  }

  InsertTypeProfile(data) {
    return this.httpService.post("Definition/insert-type-color", data, {
      headers,
    });
  }

  getType(params) {
    return this.httpService.get("Definition/combo-type-color", {
      headers,
      params,
    });
  }

  getSelectColor(params) {
    return this.httpService.get("Definition/all-color", { headers, params });
  }

  editNameColor(data) {
    return this.httpService.put("Definition/update-color", data, { headers });
  }

  AddColor(data) {
    return this.httpService.post("Definition/insert-color", data, { headers });
  }

  AddTypeColor(data) {
    return this.httpService.post("Definition/insert-type-color", data, {
      headers,
    });
  }

  InsertProductProfile(data) {
    return this.httpService.post("Definition/insert-product-profile", data, {
      headers,
    });
  }

  deleteColor(data) {
    return this.httpService.delete("Definition/delete-color", {
      headers,
      data,
    });
  }

  getRelationColor(params) {
    return this.httpService.get("Definition/relation-color", {
      headers,
      params,
    });
  }

  disableColorProfile(data) {
    return this.httpService.delete("Definition/disable-color", {
      headers,
      data,
    });
  }

  deleteTypeProfile(data) {
    return this.httpService.delete("Definition/delete-type-color", {
      headers,
      data,
    });
  }

  getRelationTypeProfile(params) {
    return this.httpService.get("Definition/relation-type-color", {
      headers,
      params,
    });
  }

  disableTypeProfile(data) {
    return this.httpService.delete("Definition/disable-type-color", {
      headers,
      data,
    });
  }
  getFixer(params) {
    return this.httpService.get("Definition/list-price-fixer", {
      headers,
      params,
    });
  }

  UpdatePriceFixer(data) {
    return this.httpService.put("Definition/set-price-fixer", data, {
      headers,
    });
  }

  getLastik(params) {
    return this.httpService.get("Definition/list-price-lastic", {
      headers,
      params,
    });
  }

  getKasriBoresh(params) {
    return this.httpService.get("definition/list-iron-part", {
      headers,
      params,
    });
  }

  UpdateKasriBoresh(data) {
    return this.httpService.put("Definition/update-iron-part", data, {
      headers,
    });
  }

  UpdatePriceLastic(data) {
    return this.httpService.put("Definition/set-price-lastic", data, {
      headers,
    });
  }

  updatePriceProductGlassGroup(data) {
    return this.httpService.put(
      "Definition/set-price-product-profile-change-list",
      data,
      { headers }
    );
  }

  getAllTypeAndColor(params) {
    return this.httpService.get("Definition/all-type-and-color", {
      headers,
      params,
    });
  }

  disableColor(data) {
    return this.httpService.put("Definition/disable-color", data, { headers });
  }

  disableTypeColor(data) {
    return this.httpService.put("Definition/disable-type-color", data, {
      headers,
    });
  }
  getColor(params) {
    return this.httpService.get("Definition/color-pattern-drawer-profile", {
      headers,
      params,
    });
  }
}

const ProfileService = new Profile();
export default ProfileService;
